module.exports = __webpack_public_path__ + "media/images/manga_bn-6de959fe1383e180369f0318f16d856e.png";